import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import { useDispatch, useSelector } from "react-redux";
import TableRow from "@mui/material/TableRow";
import { Button, IconButton, TextField, Tooltip } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import DeleteIcon from "@mui/icons-material/Delete";
import Typography from "@mui/material/Typography";
import { createCompanyCategory } from "../../actions/category";

import secureLocalStorage from "react-secure-storage";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet-async";

const columns = [
  { id: "asset_pool", label: "Asset Pool", minWidth: 100 },
  {
    id: "code",
    label: "CODE",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "intangible_category",
    label: "Intangible Category",
    minWidth: 170,
    align: "right",
    format: (value) => value.toString(),
  },
];

export default function Categories() {
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "15px",
    width: 400,
    backgroundColor: `${mode === "dark" ? "#ccc" : "#ffffff"}`,
    color: `${mode === "dark" ? "#fff" : "#000"}`,
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // const assetCat = useSelector((state) => state.category);

  let [category, setCategory] = React.useState({
    code: "",
    asset_pool: "",
    intangible_category: false,
  });
  // category.intangible_category = checked;
  const dispatch = useDispatch();
  function sendData() {
    if (category.code && category.asset_pool) {
      dispatch(createCompanyCategory(category));
    } else {
      toast.error("asset pool and code are required");
    }
  }

  const categories = useSelector((state) => state.category);
  const intangibleCat = [
    {
      asset_pool: "INTANGIBLES",
      code: "IA",
      intangible_category: "true",
      id: "6463e2c9b03c40ecfc0c8bm2",
    },
  ];
  const newCategory = [...categories, ...intangibleCat];
  const handleChange = (event) => {
    let isChecked = event.target.checked;
    setCategory({ ...category, intangible_category: isChecked });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleClose = () => {
    setCategory({
      code: "",
      asset_pool: "",
      intangible_category: false,
    });
    setOpen(false);
  };
  let allowManipulate = false;
  if (
    user.results.assets === "Administrator" ||
    user.results.assets === "Read-Write"
  ) {
    allowManipulate = true;
  } else {
    allowManipulate = false;
  }
  return (
    <div
      style={{
        backgroundColor: `${mode === "dark" ? "#101418" : "#ffffff"}`,
        color: `${mode === "dark" ? "#fff" : "#000"}`,
        height: "calc(77dvh - 100px)",
      }}>
      <Helmet>
        <title>Asset Pools</title>
      </Helmet>
      <Paper
        style={{
          backgroundColor: `${mode === "dark" ? "#303030" : "#ffffff"}`,
          color: `${mode === "dark" ? "#fff" : "#000"}`,
        }}
        sx={{ width: "100%" }}>
        <Modal
          aria-labelledby='transition-modal-title'
          aria-describedby='transition-modal-description'
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}>
          <Fade in={open}>
            <Box sx={style}>
              <Typography
                id='transition-modal-title'
                variant='h5'
                component='h2'
                style={{ marginBottom: "15px", color: "#000000" }}>
                Add Category
              </Typography>
              <form>
                <TextField
                  style={{ marginBottom: "10px" }}
                  type='text'
                  size='small'
                  label='Asset Pool'
                  value={category.asset_pool}
                  onChange={(e) =>
                    setCategory({ ...category, asset_pool: e.target.value })
                  }
                  required
                />
                <TextField
                  style={{ marginBottom: "10px" }}
                  type='text'
                  size='small'
                  label='Code'
                  value={category.code}
                  onChange={(e) =>
                    setCategory({ ...category, code: e.target.value })
                  }
                  required
                />
                <FormControlLabel
                  style={{
                    color: "#000000",
                  }}
                  control={
                    <Checkbox
                      // checked={intangible_category}
                      // defaultChecked
                      onChange={handleChange}
                      name='intangible_category'
                    />
                  }
                  label='Intangible Category?'
                />

                <div>
                  <Button
                    onClick={sendData}
                    variant='contained'
                    size='small'
                    style={{
                      textTransform: "none",
                      margin: "5px",
                      backgroundColor: "#116149",
                    }}>
                    Submit
                  </Button>
                  <Button
                    variant='contained'
                    style={{
                      textTransform: "none",
                      backgroundColor: "#D32F2F",
                    }}
                    onClick={handleClose}
                    size='small'>
                    Cancel
                  </Button>
                </div>
              </form>
            </Box>
          </Fade>
        </Modal>
        <Button
          disabled={!allowManipulate}
          style={{
            textTransform: "capitalize",
            margin: "5px",
            backgroundColor: `${mode === "dark" ? "#0883FF" : "#116149"}`,
          }}
          onClick={handleOpen}
          variant='contained'>
          Add Category
        </Button>
        <em style={{ color: "red" }}>
          {allowManipulate
            ? ""
            : "you don't have the permission to add asset pool"}
        </em>
        <TableContainer style={{ height: "calc(73dvh - 100px)" }}>
          <Table
            size='small'
            stickyHeader
            aria-label='sticky table'
            // style={{ backgroundColor: "#E9F1F7" }}
            sx={{
              "& tr > *:last-child": {
                position: "sticky",
                right: 0,

                // bgcolor: "#cccc",
              },
            }}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      top: 0,
                      minWidth: column.minWidth,
                      backgroundColor: "#3D4F58",
                      color: "white",
                    }}>
                    {column.label}
                  </TableCell>
                ))}
                <TableCell
                  align='center'
                  style={{ backgroundColor: "#3D4F58", color: "white" }}>
                  ACTIONS
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {newCategory
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                ?.map((row) => {
                  return (
                    <TableRow hover role='checkbox' tabIndex={-1} key={row.id}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            style={{
                              backgroundColor: `${
                                mode === "dark" ? "#303030" : "#ffffff"
                              }`,
                              color: `${
                                mode === "dark"
                                  ? "rgba(255,255,255,0.65)"
                                  : "#000"
                              }`,
                            }}
                            key={column.id}
                            align={column.align}>
                            {column.format && typeof value === "number"
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                      <TableCell>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                            fontSize: "14px",
                          }}>
                          <Tooltip title='Delete'>
                            <IconButton>
                              <DeleteIcon
                                style={{ fontSize: "18px", color: "red" }}
                              />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          style={{
            color: `${mode === "dark" ? "#fff" : "#000"}`,
          }}
          component='div'
          count={newCategory.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
